/**
 * Format a date string or Date object to a consistent display format.
 * Returns "YYYY-MM-DD HH:mm" by default.
 */
export function formatDate(input: string | Date | undefined | null, showTime = true): string {
  if (!input) return '-';
  const d = typeof input === 'string' ? new Date(input) : input;
  if (isNaN(d.getTime())) return '-';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  if (!showTime) return `${year}-${month}-${day}`;

  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}
